import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppHeader from '../components/AppHeader';

const AboutUs = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-dark text-light flex flex-col">
            <AppHeader />

            <main className="flex-1 w-full max-w-4xl mx-auto p-6 md:p-8 mt-[70px]">
                <button
                    onClick={() => navigate(-1)}
                    className="flex items-center text-gold mb-6 hover:text-yellow-500 transition-colors"
                >
                    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                    </svg>
                    Back
                </button>

                <h1 className="text-4xl md:text-5xl font-bold text-gold mb-8 text-center">About Vivara</h1>

                <div className="space-y-8 bg-gray-800 p-8 rounded-2xl shadow-xl">
                    <section>
                        <h2 className="text-2xl font-semibold text-white mb-4">Our Vision</h2>
                        <p className="text-gray-300 leading-relaxed">
                            Vivara is dedicated to democratizing services by bridging the gap between world-class specialized professionals and users globally.
                            Our vision is to construct a unified digital service ecosystem where quality service is accessible, affordable, and immediate, regardless of geographical boundaries.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-white mb-4">What We Do</h2>
                        <p className="text-gray-300 leading-relaxed mb-4">
                            We provide a comprehensive digital platform that seamlessly connects:
                        </p>
                        <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                            <li><strong className="text-gold">Users:</strong> Get instant access to verified specialists, book sessions, access live wellness classes, and order recommended products directly to your door.</li>
                            <li><strong className="text-gold">Providers:</strong> Expand your services digitally, manage user records securely, and conduct high-quality video sessions anywhere, anytime.</li>
                            <li><strong className="text-gold">Centers & Organizations:</strong> Manage multiple providers, streamline sessions, and elevate user experience through our robust B2B tools.</li>
                            <li><strong className="text-gold">Retailers:</strong> Receive digital recommendations instantly and manage product deliveries with complete transparency.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-white mb-4">Our Commitment</h2>
                        <p className="text-gray-300 leading-relaxed">
                            Security and privacy are at the core of our platform. We deploy state-of-the-art encryption to ensure that all platform data, session records, and personal information remain strictly confidential.
                            Vivara operates under strict compliance with data protection standards.
                        </p>
                    </section>
                </div>

                <div className="mt-12 text-center text-gray-500 text-sm pb-8">
                    <p>&copy; {new Date().getFullYear()} Vivara Platform. All rights reserved.</p>
                </div>
            </main>
        </div>
    );
};

export default AboutUs;
